export const AUTO_ACCEPTED = 'AUTO_ACCEPTED';
export const ACCEPTED = 'ACCEPTED';
export const REQUIRES_REVIEW = 'REQUIRES_REVIEW';
export const REJECTED = 'REJECTED';
